import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton, CardImg, OverlayTrigger } from 'react-bootstrap';
import { context } from '../../AppContext';
//import { context as api } from '../../AppContext';
import Locale from "../../../locale/Locale";
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';


let api;

export default class HistoryItem extends React.Component {

    state = {};

    constructor(props) {
        super();
        api = context.getMobileMock(props.allConfigs);
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(err, errorInfo) {
        console.log(err, errorInfo);
    }

    phraseChange() {
        let pn = this.props.record.Param || this.props.record.ParamName;
        let cn = this.props.record.ControlName;
        let config = api.getCurrentConfig();
        let control = api.getControlByUuid(this.props.record.Control, config);
        if (control) {
            cn = control.Name;
        }
        let cnCnt = config.data.Controls.filter(ctrl => ctrl.Name === cn);
        if (cnCnt?.length > 1) {
            if (control) {
                let controlGroup = config.data.ControlGroups.find(ctrlg => ctrlg.UUID === control.ControlGroupUUID);
                if (controlGroup)
                    cn = controlGroup.Name + " " + cn;
            }
        }
        //console.log(Object.keys(this.props.allConfigs));

        if (pn === 'Status') {
            return Locale.gettext('%s %s', cn, this.props.record.Status === 'ON' ? Locale.gettext('On') : Locale.gettext('Off'));
        } else if (pn === 'PowerLevel') {
            return Locale.gettext('%s speed to %s', cn, this.props.record.Status);
        } else if (pn === 'Brightness') {
            return Locale.gettext('%s brightness to %s', cn, this.props.record.Status);
        } else if (pn === 'LightName') {
            // LightName is actually a UUID field for custom colors
            const palette = api.getCurrentConfig("Palette.json");
            let lightName = palette?.data?.colors?.find(
                item => item.uuid === this.props.record.Status
            )?.name ?? this.props.record.Status
            if (lightName.substring(0,1) === "#")
                lightName = Locale.gettext("Custom color");
            return Locale.gettext('%s color to %s', cn, lightName);
        } else if (pn === 'SetPoint') {
            return Locale.gettext('%s temperature to %s', cn, Math.round(api.convertTemp(this.props.record.Status)));
        } else if (pn === 'ControlMode') {
            return Locale.gettext('%s Mode to %s', cn, this.props.record.Status);
        } else if (pn === 'CurrentAcidMixEvent') {
            let details = JSON.parse(this.props.record.Status);
            return Locale.gettext('Lowered water PH (%1$d seconds)', details.DoseSeconds);
        } else if (pn === 'CurrentLiquidChlorineMixEvent') {
            let body = config.data.BodiesOfWater.find(ctrl => ctrl.UUID === this.props.record.Device);
            let bodyName = body?.Name || Locale.gettext('Water');
            let details = JSON.parse(this.props.record.Status);
            return Locale.gettext('Added sanitizer to %1$s for %2$s and mixed water until %3$s', bodyName, Locale.formatTimeInterval(details.DoseSeconds), Locale.formatTime(new Date(details.EndDateTime)));
        } else if (pn === 'CurrentSaltChlorinatorMixEvent') {
            let body = config.data.BodiesOfWater.find(ctrl => ctrl.UUID === this.props.record.Device);
            let bodyName = body?.Name || Locale.gettext('Water');
            let details = JSON.parse(this.props.record.Status);
            let duration = (new Date(details.EndDateTime).getTime() - new Date(details.StartDateTime).getTime()) / 1000;
            return Locale.gettext('Added sanitizer to %1$s for %2$s', bodyName, Locale.formatTimeInterval(duration));
        } else if (pn === 'FreezeProtectStart') {
            return this.props.record.Status !== "null" ? Locale.gettext('Freeze protect turned on') : Locale.gettext('Freeze protect turned off');
        } else if (pn === 'FreezeProtectPaused') {
            return this.props.record.Status !== "null" ? Locale.gettext('Freeze protect paused') : Locale.gettext('Freeze protect resumed');
        } else if (pn === 'Connected') {
            //console.log(this.props.record);
            return this.props.record.Status === 1 ? Locale.gettext('Device connected to cloud') : Locale.gettext('Device disconnected from cloud');
        } else if (pn === 'Mode') {
            let modeName = this.props.record.Status.toUpperCase().substring(0,1) + this.props.record.Status.toLowerCase().substring(1);
            //console.log(this.props.record);
            return Locale.gettext('Set Mode to %s', modeName);
        } else if (pn === 'Theme') {
            //console.log(this.props.record);
            if (this.props.record.Status === null) {
                return Locale.gettext('Stop theme playlist');
            }
            try {
                let themeConfig = api.getCurrentConfig('Themes.json');
                let themeList = Array.isArray(themeConfig.data) ? themeConfig.data : [];
                let themeMacroConfig = api.getCurrentConfig('ThemeMacros.json');
                let themeMacroList = Array.isArray(themeMacroConfig.data) ? themeMacroConfig.data : [];
                let themeOrMacro = themeList.find(th => th.UUID === this.props.record.Status) || 
                                    themeMacroList.find(th => th.UUID === this.props.record.Status);
                if (themeOrMacro.Themes)
                    return Locale.gettext('Activate theme playlist %s', themeOrMacro?.Name || "");
                return Locale.gettext('Activate theme %s', themeOrMacro?.Name || "");
            } catch {
                return Locale.gettext('Activate theme');
            }
        } else if (pn === 'AwayMode') {
            //console.log(this.props.record);
            let awayState = api.getAwayModeStatus([this.props.record.Status]);
            return {
                source: api.getUpcomingEventPerformerName(awayState.Settings, ""),
                phrased: Locale.gettext('Set Away Mode to %s', awayState.AwayModeOn ? Locale.gettext('On') : Locale.gettext("Off"))
            };
        } else if (pn === 'AlertState') {
            return this.props.record.Status === 'OPEN' ? Locale.gettext('Alert created') : Locale.gettext('Alert Closed');
        } else if (pn === 'PausedUntil') {
            if (this.props.record.Status === 0)
                return Locale.gettext('Resumed Freeze Protect');
            return Locale.gettext('Paused Freeze Protect for %s', Locale.formatTimeInterval(this.props.record.Status));
        } else if (pn === 'ScheduleEventCancelled') {
            let details = JSON.parse(this.props.record.Status);
            const uuid = details.ItemUUID ?? details.ControlUUID;
            const control = api.getControlByUuid(uuid) ?? { Name: Locale.gettext('unknown') };
            return {
                source: api.getUpcomingEventPerformerName(details.LastCanceled, ""),
                phrased: Locale.gettext('Canceled %1$s event at %2$s', control.Name, Locale.formatTime(new Date(details.StartDateTime)))
            }
        } else if (pn === 'ScheduleEventInterrupted') {
            let details = JSON.parse(this.props.record.Status);
            const uuid = details.ItemUUID ?? details.ControlUUID;
            const control = api.getControlByUuid(uuid) ?? { Name: Locale.gettext('unknown') };
            return {
                source: api.getUpcomingEventPerformerName(details.LastInterrupted, ""),
                phrased: Locale.gettext('Interrupted %1$s event from %2$s', control.Name, Locale.formatTime(new Date(details.StartDateTime)))
            }
        } else if (pn === 'ScheduleEventResumed') {
            let details = JSON.parse(this.props.record.Status);
            const uuid = details.ItemUUID ?? details.ControlUUID;
            const control = api.getControlByUuid(uuid) ?? { Name: Locale.gettext('unknown') };
            let resumeAction = details.EventActions?.reverse().find(ev => ev.Action === 'ACTIVE');
            //console.log("resumeAction", resumeAction);
            return {
                source: api.getUpcomingEventPerformerName(resumeAction, ""),
                phrased: Locale.gettext('Resumed %1$s event at %2$s', control.Name, Locale.formatTime(new Date(details.StartDateTime)))
            }
        }

        return cn + ' ' + this.props.record.Param + ' => ' + this.props.record.Status;
    }

    render(props) {
        if (this.state.hasError) {
            return (
                <tr 
                    style={{ border: '1px solid' }}
                >
                    <td style={{ }}>
                        { Locale.formatDateTime(this.props.record.time) }
                    </td>
                    <td style={{  }}>
                        { this.props.record.SourceName }
                    </td>
                    <td style={{ color: 'red' }}>
                        { Locale.gettext("Error rendering") }
                    </td>
                </tr>
            );
        }
        let parts = this.phraseChange();
        if (typeof parts === "string") {
            parts = {
                source: context.getUpcomingEventPerformerName(this.props.allConfigs.Config, this.props.record, Locale.gettext("Unknown")),
                phrased: parts
            };
        }
        return (
            <tr 
                style={{ border: '1px solid' }}
            >
                <td style={{ }}>
                    { Locale.formatDateTime(this.props.record.time)  }
                </td>
                <td style={{  }}>
                    { parts.source }
                    <div style={{ display: 'none' }}>
                        { this.props.record.Source }<br/>
                        { this.props.record.SourceName }
                    </div>
                </td>
                <td style={{ }}>
                    { parts.phrased }
                </td>
            </tr>
        );
    }
}